import {
  ClinicalTrialInventoryDictionaryType,
  ClinicalTrialInventoryFunctionType,
  ClinicalTrialInventoryInstrumentType,
  ClinicalTrialInventoryMeasurementType,
  ClinicalTrialInventoryReaderType,
  ClinicalTrialInventoryReportTemplatesType,
  ClinicalTrialInventoryScoringFormType,
  ClinicalTrialInventoryBaseType,
  ClinicalTrialInventoryType,
} from '@dynamika-shared/types/clinicalTrialInventory';
import { getClient } from './client';
import { fetchClinicalTrialInventoryMock } from './mocks/clinicalTrialInventory';
import { prepareUrl } from 'src/utils/routerHelpers';
import { API_URL, CLINICAL_TRIAL_INVENTORY_API } from './apiDictionary';

export const fetchClinicalTrialInventory = async (id: string) => {
  fetchClinicalTrialInventoryMock(id);
  return getClient(
    API_URL.clinicalTrialInventory
  ).get<ClinicalTrialInventoryType>(
    prepareUrl(API_URL.clinicalTrialInventory, [id]),
    {
      headers: {
        'x-dynamika-clinical-trial-id': id,
      },
    }
  );
};

export const fetchClinicalTrialInventoryInstrumentsForImageSpecialist = async (id: string) => {
  fetchClinicalTrialInventoryMock(id);
  return getClient(
    API_URL.clinicalTrialInventoryInstrumentsForImagingSpecialist
  ).get<ClinicalTrialInventoryType>(
    prepareUrl(API_URL.clinicalTrialInventoryInstrumentsForImagingSpecialist, [id]),
    {
      headers: {
        'x-dynamika-clinical-trial-id': id,
      },
    }
  );
};

export const fetchClinicalTrialUtilsInventory = async (id: string) => {
  fetchClinicalTrialInventoryMock(id);
  return getClient(
    API_URL.clinicalTrialUtilsInventory
  ).get<ClinicalTrialInventoryType>(
    prepareUrl(API_URL.clinicalTrialUtilsInventory, [id])
  );
};

type BodyType<T> = Omit<T, 'id' | 'clinicalTrialId'>;

type ApiDataType<T, TCreate = BodyType<T>, TUpdate = BodyType<T>> = {
  get: (ctId: string, itemId: string) => Promise<T>;
  create: (ctId: string, data: TCreate) => Promise<void>;
  update: (ctId: string, itemId: string, data: TUpdate) => Promise<void>;
  delete: (ctId: string, itemId: string) => Promise<void>;
};

export const createApiMethods = <T>(route: string): ApiDataType<T> => {
  return {
    get: async (ctId, itemId) =>
      getClient(route)
        .get(prepareUrl(route, [ctId, itemId]))
        .then(res => res.data),
    create: async (ctId, data) =>
      getClient(route).post(prepareUrl(route, [ctId]), data),

    update: async (ctId, itemId, data) =>
      getClient(route).put(prepareUrl(route, [ctId, itemId]), data),

    delete: async (ctId, itemId) =>
      getClient(route).delete(prepareUrl(route, [ctId, itemId])),
  };
};

export const clinicalTrialInventoryApi = {
  scoringForms: createApiMethods<ClinicalTrialInventoryScoringFormType>(
    CLINICAL_TRIAL_INVENTORY_API.clinicalTrialInventoryScoringForms
  ),
  tags: createApiMethods<ClinicalTrialInventoryBaseType>(
    CLINICAL_TRIAL_INVENTORY_API.clinicalTrialInventoryTags
  ),
  functions: createApiMethods<ClinicalTrialInventoryFunctionType>(
    CLINICAL_TRIAL_INVENTORY_API.clinicalTrialInventoryFunctions
  ),
  measurements: createApiMethods<ClinicalTrialInventoryMeasurementType>(
    CLINICAL_TRIAL_INVENTORY_API.clinicalTrialInventoryMeasurements
  ),
  readers: createApiMethods<ClinicalTrialInventoryReaderType>(
    CLINICAL_TRIAL_INVENTORY_API.clinicalTrialInventoryReaders
  ),
  instruments: createApiMethods<ClinicalTrialInventoryInstrumentType>(
    CLINICAL_TRIAL_INVENTORY_API.clinicalTrialInventoryInstruments
  ),
  reportTemplates: createApiMethods<ClinicalTrialInventoryReportTemplatesType>(
    CLINICAL_TRIAL_INVENTORY_API.clinicalTrialInventoryReportTemplates
  ),
  dictionaries: createApiMethods<ClinicalTrialInventoryDictionaryType>(
    CLINICAL_TRIAL_INVENTORY_API.clinicalTrialInventoryDictionaries
  ),
};

